export const UnassignedDeliveriesComponentName: string = 'unassignedDeliveries';
